import { useRef, useState, useCallback } from 'react';

/**
 * Evita envíos duplicados por doble clic en botones de escritura.
 * Usa ref para bloqueo síncrono y state para deshabilitar el botón en UI.
 */
export default function useSubmitLock() {
	const lockRef = useRef(false);
	const [submitting, setSubmitting] = useState(false);

	const runWithSubmitLock = useCallback(async (fn) => {
		if (lockRef.current) return;
		lockRef.current = true;
		setSubmitting(true);
		try {
			return await fn();
		} finally {
			lockRef.current = false;
			setSubmitting(false);
		}
	}, []);

	return { submitting, runWithSubmitLock };
}
